import { makeStyles } from '@material-ui/core/styles';

export const useMobilePortalNavigationStyles = makeStyles(
  ({ breakpoints, spacing }) => ({
    backButtonContainer: {
      padding: spacing(1, 4),
      [breakpoints.up('md')]: {
        padding: 0,
      },
    },
  }),
  { name: 'MobilePortalNavigation' },
);
